<div class="container_dialog">
    <div class="header_popup header_popup_center">
      <div class="title_popup title_popup_center">
        <span>{{"companies.basic_information"|translate}}</span>
      </div>
      <button (click)="closed()">
        <mat-icon style="color: black;">close</mat-icon>
      </button>
    </div>
    <form class="display_form" [formGroup]="form">
      <div class="input_field">
        <label>{{"companies.company_name"|translate}}</label>
        <input
          class="input"
          type="text"
          formControlName="name"
          [placeholder]="'companies.company_name'|translate"
        />
        <span class="error_ms" *ngIf="form.get('name')?.touched && form.get('name')?.errors">{{"common.required_field"|translate}}</span>
      </div>
      <div class="input_field">
        <label>{{"companies.companies_id"|translate}}</label>
        <input
          class="input"
          type="text"
          formControlName="company_id"
          [placeholder]="'companies.companies_id'|translate"
        />
        <span class="error_ms" *ngIf="form.get('company_id')?.touched && form.get('company_id')?.errors">{{"common.required_field"|translate}}</span>
      </div>
    </form>
    <div class="submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
        <span>{{"common.back"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <button class="save_btn_pop_up blue_btn" (click)="save()">
        <span> {{"common.save"|translate | uppercase}} </span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
